import { Enumeration } from './Enumeration';

class AddressFormatsEnum extends Enumeration {
  Unstructured = 'Unstructured';
  Street = 'Street';
  POBox = 'POBox';
  FreeText = 'Freetext';
  Foreign = 'Foreign';

  constructor() {
    super();
    return Object.freeze(this);
  }
}

export const AddressFormats = new AddressFormatsEnum();
